import { map, reject } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';
import db from '../../hooks/useFirebase';
import { v1 as uuid } from 'uuid';
// import axios from '../../utils/axios';
const { detect } = require('detect-browser');
// ----------------------------------------------------------------------

const initialState = {
  isLoading: true,
  error: false,
  myProfile: null,
  posts: [],
  users: [],
  userList: [],
  offersList: [],
  followers: [],
  friends: [],
  gallery: [],
  cards: null,
  addressBook: [],
  invoices: [],
  notifications: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PROFILE
    getProfileSuccess(state, action) {
      state.isLoading = false;
      state.myProfile = action.payload;
    },

    // GET POSTS
    getPostsSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET USERS
    getUsersSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },

    // DELETE USERS
    deleteUser(state, action) {
      state.userList = reject(state.userList, { id: action.payload });
    },

    // GET FOLLOWERS
    getFollowersSuccess(state, action) {
      state.isLoading = false;
      state.followers = action.payload;
    },

    // ON TOGGLE FOLLOW
    onToggleFollow(state, action) {
      const followerId = action.payload;

      const handleToggle = map(state.followers, (follower) => {
        if (follower.id === followerId) {
          return {
            ...follower,
            isFollowed: !follower.isFollowed
          };
        }
        return follower;
      });

      state.followers = handleToggle;
    },

    // GET FRIENDS
    getFriendsSuccess(state, action) {
      state.isLoading = false;
      state.friends = action.payload;
    },

    // GET GALLERY
    getGallerySuccess(state, action) {
      state.isLoading = false;
      state.gallery = action.payload;
    },

    // GET MANAGE USERS
    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.userList = action.payload;
    },

    // GET CARDS
    getCardsSuccess(state, action) {
      state.isLoading = false;
      state.cards = action.payload;
    },

    // GET ADDRESS BOOK
    getAddressBookSuccess(state, action) {
      state.isLoading = false;
      state.addressBook = action.payload;
    },

    // GET INVOICES
    getInvoicesSuccess(state, action) {
      state.isLoading = false;
      state.invoices = action.payload;
    },

    // GET NOTIFICATIONS
    getNotificationsSuccess(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteUser } = slice.actions;

// ----------------------------------------------------------------------

const createStartUserData = async (uid) => {
  // стартовые данные для юзера
  /*
  try {
    const id = uuid()
    const message = {
      id,
      action: 1,
      avatar: "https://firebasestorage.googleapis.com/v0/b/asys24.appspot.com/o/icon.png?alt=media&token=55afadd5-041c-403e-a6e9-ec156fe7f25d",
      message: "Приветствую Вас! Я Ваш персональный ассистент. Я буду уведомлять Вас о новых вакансиях, а так же событиях и новостях нашей платформы. А сейчас предлагаю Вам создать свое первое Видеорезюме. Ваши видеорезюме находятся на главном экране. Успехов!",
      status: true,
      name: "Personal Assystant",
      user: uid,
      time: new Date().getTime()
    }
    db.firestore().collection('messages').doc(id).set(message)
  } catch (e) {
    console.log(e)
  }

  try {
    const id = uuid()
    const message = {
      id,
      action: 3,
      avatar: "https://firebasestorage.googleapis.com/v0/b/asys24.appspot.com/o/icon.png?alt=media&token=55afadd5-041c-403e-a6e9-ec156fe7f25d",
      message: "Перейдите в настройки профиля, проверьте и актуализируйте Вашу информацию. Спасибо!",
      status: true,
      name: "Personal Assystant",
      user: uid,
      time: new Date().getTime()
    }
    db.firestore().collection('messages').doc(id).set(message)
  } catch (e) {
    console.log(e)
  }
  */

  try {
    const templateQuery = await db.firestore().collection('offers_template_choose').doc("base").get()
    const template = templateQuery.data();
    
    let templateChooseQuery = await db.firestore().collection('offers_templates').doc(template.uid).get()
    
    const fetchedData = []
    await db.firestore().collection('offers_templates').doc(template.uid).collection('questions').get().then(response => {
      response.forEach(document => {
        let fetched = {
          ...document.data()
        };
        fetchedData.push(fetched);
      });
    });

    const id = uuid()
    const offer = {
      id: id,
      ...templateChooseQuery.data(),
      questions: [...fetchedData],
      status: false,
      video: "",
      user: uid,
      time: new Date().getTime()
    }
    db.firestore().collection('offers').doc(id).set(offer)
  } catch (e) {
    console.log(e)
  }
}  

const pushCandidateToApi = async (data) => {
	try {
		const requestOptions = {
			method: "POST",
			header: {
				"Accept": "application/json, text-plain, */*",
				"X-Requested-With": "XMLHttpRequest",
			},
			credentials: "same-origin",
			body: JSON.stringify({
				data: data,
			})
		};

		let response = await fetch("https://api.asystent.biz/api/candidates", requestOptions)
			.then(response => {
				if (!response.ok) throw Error(response.statusText);
				return response.json();
			})
			.then(data => {
				return data
			})
			.catch(error => {
				let err = {}
				err.error = true
				err.text = error
				return err
			});
		return response
	} catch (e) {
		console.error(e)
	}
}

const uploadPhoto = async (image) => {
  try {
    const uploadTask = await db.storage().ref().child(uuid()).put(image)
    const downloadURL = await uploadTask.ref.getDownloadURL()
    return downloadURL
  } catch(e) {
    console.error(e)
  }
}

const uploadCV = async (file) => {
  try {
    const uploadTask = await db.storage().ref().child("a_cv/"+uuid()).put(file)
    const downloadURL = await uploadTask.ref.getDownloadURL()
    return downloadURL
  } catch(e) {
    console.error(e)
  }
}

export async function updateUserResume(values,uid) {
  try {
    let userData = {
      date: new Date().getTime(),
      resume_acourses_data: values.acourses,
      resume_skills: values.skills,
      resume_links: values.links_data,
      resume_activity: values.dod_act,
      resume_interests: values.interests,
      resume_education_data: values.study_data,
      resume_workex_data: values.company_data,
      resume_languages_data: values.languages_data,
      resume_courses_data: values.courses_data,
    }
    //&& api user
    await axios.post('https://api.asystent.biz/api/candidates/update-resume-api/'+uid,userData); 
  
    return uid
  } catch(error) {
    console.log(error)
  }
}

export async function sendEmailVerify(email,name) {
  try {
    //&& api user
    let res = await axios.get('https://api.asystent.biz/api/candidates/send-mail-verify/'+email+"/"+name); 
  
    return res
  } catch(error) {
    console.log(error)
  }
}

export async function updateUserActivity(uid) {
  try {
    //&& api user
    let res = await axios.get('https://api.asystent.biz/api/candidates/update/'+uid); 
  
    return res
  } catch(error) {
    console.log(error)
  }
}

export async function deleteUserAll(uid) {
  try {
    let user = await db.firestore().collection('users').doc(uid).get();
    let documentData =  user.data();
    let phone
    
    if(documentData) {
      phone = documentData.phone_verify_uid?documentData.phone_verify_uid:false

      let initialQuery = await db.firestore().collection('offers').where("user","==",uid).limit(1000);
      let documentSnapshots = await initialQuery.get();
      documentSnapshots.docs.map(async (document) => {
        let data = document.data()

        if(data) {
          let desertRef = await db.storage().ref().child("videos/"+data.video_name);
          await desertRef.delete();
        }

        await db.firestore().collection('offers').doc(data.id).delete()
      });

      await db.firestore().collection('users').doc(uid).delete()
    }

    await axios.delete('https://api.asystent.biz/api/candidates/dell-all/'+uid+"/"+phone);

    return uid
  } catch(error) {
    console.log(error)
  }
}

export async function updateCommentUser(comment,uid) {
  try {
    let userData = {
      comment,
    }
    //&& api user
    await axios.post('https://api.asystent.biz/api/candidates/update-comment-api/'+uid,userData); 
  
    return uid
  } catch(error) {
    console.log(error)
  }
}

export async function updateUser(values,uid) {
  let photoUrl = values.photoURL.file==undefined?values.photoURL:""

  if(values.photoURL.file!=undefined) {
    photoUrl = await uploadPhoto(values.photoURL.file)
  }

  let userData = {
    category: values.category,
    city: values.city,
    status: values.status==true?1:2,
    date: new Date().getTime(),
    username: values.username,
    date_of_bird: values.date_of_bird,
    bio: values.bio,
    photo: photoUrl,
  }

  await db.firestore()
    .collection('users')
    .doc(uid)
    .update(userData);

  console.log(userData)

  //&& api user
  await axios.post('https://api.asystent.biz/api/candidates/update-api/'+uid,userData); 

  return uid
}

export async function updateUserCV(values,uid) {
  
  let cvURL = values.cvURL.file==undefined?values.cvURL:"";

  if(values.cvURL.file!=undefined) {
    cvURL = await uploadCV(values.cvURL.file)
  }

  let userData = {
    status_cv: values.status_cv==true?1:2,
    cvURL: cvURL,
    cv_name: values.cv_name,
  }

  await db.firestore()
    .collection('users')
    .doc(uid)
    .update(userData);

  //&& api user
  await axios.post('https://api.asystent.biz/api/candidates/update-cv-api/'+uid,userData); 

  return uid
}

export async function registerUser(values) {
  let result = await db.auth().createUserWithEmailAndPassword(values.email, values.password).then(async (res) => 
  {
    // db.auth().signOut();
    let authDet = JSON.parse(localStorage.getItem('upro'));
    console.log(authDet)
    let result = await db.auth().signInWithEmailAndPassword(authDet.email, authDet.pass).then(async () => {
      let photoUrl = ""
      if(values.photoURL.preview) {
        photoUrl = await uploadPhoto(values.photoURL.file)
      }

      let userData = {
        uid: res.user.uid,
        email: values.email,
        phone: values.phone,
        category: values.category,
        city: values.city,
        status: values.status==true?1:2,
        date: new Date().getTime(),
        username: values.username,
        date_of_bird: values.date_of_bird,
        bio: values.bio,
        photo: photoUrl,
        role: "user",
        token: "",
      }
      console.log(userData)

      await db.firestore()
        .collection('users')
        .doc(res.user.uid)
        .set(userData);

        //start user data && api user
        pushCandidateToApi(userData)

        res.user.uid && createStartUserData(res.user.uid);

        return res.user.uid
      }).catch( error => {
        return error
      });

      return result
    })
    .catch((error) => {
      return error
    });

  return result
}

export async function getOffers(uid) {
  // console.log("uid",uid)
  try {
    let initialQuery = await db.firestore().collection('offers').where("user","==",uid).limit(1000);
    let documentSnapshots = await initialQuery.get();
    let documentData = documentSnapshots.docs.map(document => document.data());

    return documentData
  } catch (error) {
    console.log(error)
  }
}

export async function getUser(uid) {
  try {
    let document = await db.firestore().collection('users').doc(uid).get();
    let documentData =  document.data();

    return documentData
  } catch (error) {
    console.log(error)
  }
}

export async function getUserApi(uid,get) {
  try {
    const response = await axios.get('https://api.asystent.biz/api/candidates/'+uid+get);

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export async function updateUserPhoneVerify(uid,phone) {
  try {
    let userData = {
      phone_verify: phone
    }
  
    await db.firestore().collection('users').doc(uid).update(userData);

    const response = await axios.get('https://api.asystent.biz/api/candidates/phone-verify-only/'+uid+"/"+phone);
    
    return response.data
  } catch (error) {
    console.log(error)
  }
}

export async function setLoginInApi(email, uid) {
  let browser = detect();
  
	let deviceLog = {
		brand: browser.os,
		modelName: browser.name,
		osName: browser.type,
		osVersion: browser.version,
		deviceYearClass: "-",
		platformFeatures: "-",
		supportedCpuArchitectures: "-",
		platformApiLevel: "-",
		ram: "-",
		email: email,
		uid: uid,
	}
	
	try {
		const requestOptions = {
			method: "POST",
			header: {
				"Accept": "application/json, text-plain, */*",
				"X-Requested-With": "XMLHttpRequest",
			},
			credentials: "same-origin",
			body: JSON.stringify({
				data: deviceLog,
			})
		};

		let response = await fetch("https://api.asystent.biz/api/login_info", requestOptions)
			.then(response => {
				if (!response.ok) throw Error(response.statusText);
				return response.json();
			})
			.then(data => {
				return data
			})
			.catch(error => {
				let err = {}
				err.error = true
				err.text = error
				return err
			});
		return response
	} catch (e) {
		console.error(e)
	}
}

export async function getUserApiHash(hash) {
  try {
    const response = await axios.get('https://api.asystent.biz/api/candidates/hash/'+hash);

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export async function getUserLink(uid) {
  try {
    const response = await axios.get('https://api.asystent.biz/api/candidates-link?uid='+uid);

    return response.data
  } catch (error) {
    console.log(error)
  }
}

// ----------------------------------------------------------------------

export function getProfile(uid) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let document = await db.firestore().collection('users').doc(uid).get()
      let response = document.data()
      console.log(response)
      dispatch(slice.actions.getProfileSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setProfileData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // console.log("setProfileData")
      dispatch(slice.actions.getProfileSuccess(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPosts() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/posts');
      dispatch(slice.actions.getPostsSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFollowers() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/social/followers');
      dispatch(slice.actions.getFollowersSuccess(response.data.followers));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFriends() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/social/friends');
      dispatch(slice.actions.getFriendsSuccess(response.data.friends));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getGallery() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/social/gallery');
      dispatch(slice.actions.getGallerySuccess(response.data.gallery));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUserList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('https://api.asystent.biz/api/candidates');

      dispatch(slice.actions.getUserListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getFilteredUsers(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('https://api.asystent.biz/api/candidates/filter',data); 
      
      dispatch(slice.actions.getUserListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function sendUserCourses(data) {
    try {
      const response = await axios.post('https://api.asystent.biz/api/candidates/sendUserCourses',data); 

      return response;
    } catch (error) {
      console.log(slice.actions.hasError(error));
    }
}

// ----------------------------------------------------------------------

export function getCards() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/cards');
      dispatch(slice.actions.getCardsSuccess(response.data.cards));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getAddressBook() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/address-book');
      dispatch(slice.actions.getAddressBookSuccess(response.data.addressBook));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getInvoices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/invoices');
      dispatch(slice.actions.getInvoicesSuccess(response.data.invoices));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNotifications() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/notifications-settings');
      dispatch(slice.actions.getNotificationsSuccess(response.data.notifications));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUsers() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/all');
      dispatch(slice.actions.getUsersSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
